import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ManageProductCategory from "../components/ManageProductCategory";

const ManageProductCategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Manage Product Category' />

        <ManageProductCategory />

      </MasterLayout>
    </>
  );
};

export default ManageProductCategoryPage;
